import type { LiquidationInput, RegisterMutation } from 'generated/gql';

export const mapLiquidationToLiquidationInput = (
  liquidation: RegisterMutation['liquidation'],
): LiquidationInput => ({
  reason: liquidation?.reason,
});
